// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-required-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,.55);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999999;
  }
  
  .login-required-modal {
    width: 90%;
    max-width: 420px;
    background: white;
    border-radius: 20px;
    padding: 30px;
    text-align: center;
    position: relative;
    animation: modalPop .25s ease;
  }
  
  .login-required-close {
    position: absolute;
    top: 15px;
    right: 15px;
    border: none;
    background: none;
    cursor: pointer;
    font-size: 18px;
  }
  
  .login-required-icon {
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background: #f3f4f6;
    margin: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
  }
  
  .login-required-modal h3 {
    margin-top: 20px;
  }
  
  .login-required-modal p {
    color: #666;
    margin: 15px 0 25px;
    line-height: 1.5;
  }
  
  .login-required-btn {
    width: 100%;
    border: none;
    background: var(--primary-100);
    color: white;
    padding: 14px;
    border-radius: 12px;
    cursor: pointer;
    font-weight: 600;
  }
  
  @keyframes modalPop {
    from {
      opacity: 0;
      transform: scale(.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }`, "",{"version":3,"sources":["webpack://./src/components/reusable/LoginRequiredModal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,2BAA2B;IAC3B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE;MACE,UAAU;MACV,oBAAoB;IACtB;IACA;MACE,UAAU;MACV,mBAAmB;IACrB;EACF","sourcesContent":[".login-required-overlay {\n    position: fixed;\n    inset: 0;\n    background: rgba(0,0,0,.55);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 999999;\n  }\n  \n  .login-required-modal {\n    width: 90%;\n    max-width: 420px;\n    background: white;\n    border-radius: 20px;\n    padding: 30px;\n    text-align: center;\n    position: relative;\n    animation: modalPop .25s ease;\n  }\n  \n  .login-required-close {\n    position: absolute;\n    top: 15px;\n    right: 15px;\n    border: none;\n    background: none;\n    cursor: pointer;\n    font-size: 18px;\n  }\n  \n  .login-required-icon {\n    width: 70px;\n    height: 70px;\n    border-radius: 50%;\n    background: #f3f4f6;\n    margin: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 28px;\n  }\n  \n  .login-required-modal h3 {\n    margin-top: 20px;\n  }\n  \n  .login-required-modal p {\n    color: #666;\n    margin: 15px 0 25px;\n    line-height: 1.5;\n  }\n  \n  .login-required-btn {\n    width: 100%;\n    border: none;\n    background: var(--primary-100);\n    color: white;\n    padding: 14px;\n    border-radius: 12px;\n    cursor: pointer;\n    font-weight: 600;\n  }\n  \n  @keyframes modalPop {\n    from {\n      opacity: 0;\n      transform: scale(.9);\n    }\n    to {\n      opacity: 1;\n      transform: scale(1);\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
